// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-container {
  display: flex;
  gap: 2rem; /* Increased gap */
  justify-content: start;
  flex-wrap: wrap;
}

.custom-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 10px; /* Slightly larger border-radius */
  padding: 2.5rem 1.5rem; /* Increased padding */
  width: 250px; /* Increased width */
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
}

.custom-card:hover {
  background-color: var(--newOrange);
  box-shadow: 0px 5px 12px rgba(0, 0, 0, 0.15); /* Slightly larger shadow */
}

.custom-card:hover .icon-circle {
  background-color: #ffffff;
}

.custom-card:hover .icon-circle .icon-style {
  color: var(--newOrange);
}

.icon-circle {
  width: 90px; /* Increased width */
  height: 90px; /* Increased height */
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.orange-circle {
  background-color: var(--newOrange);
}

.gray-circle {
  background-color: #e0e0e0;
}

.icon-style {
  font-size: 35px; /* Increased font size */
  color: white;
}

.card-title {
  margin-top: 1.2rem;
  font-size: 1.5rem; /* Increased font size */
  font-weight: 600;
  color: #333;
}

/* Responsive design */
@media (max-width: 768px) {
  .card-container {
    flex-direction: column;
    align-items: start;
  }
  .custom-card {
    width: 90%; /* Adjusted width for mobile */
    max-width: 280px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/BusinessPartner/businessAddCustomer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS,EAAE,kBAAkB;EAC7B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB,EAAE,kCAAkC;EACvD,sBAAsB,EAAE,sBAAsB;EAC9C,YAAY,EAAE,oBAAoB;EAClC,eAAe;EACf,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,4CAA4C,EAAE,2BAA2B;AAC3E;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW,EAAE,oBAAoB;EACjC,YAAY,EAAE,qBAAqB;EACnC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe,EAAE,wBAAwB;EACzC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB,EAAE,wBAAwB;EAC3C,gBAAgB;EAChB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,UAAU,EAAE,8BAA8B;IAC1C,gBAAgB;EAClB;AACF","sourcesContent":[".card-container {\n  display: flex;\n  gap: 2rem; /* Increased gap */\n  justify-content: start;\n  flex-wrap: wrap;\n}\n\n.custom-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n  border-radius: 10px; /* Slightly larger border-radius */\n  padding: 2.5rem 1.5rem; /* Increased padding */\n  width: 250px; /* Increased width */\n  cursor: pointer;\n  transition: background-color 0.3s ease, box-shadow 0.3s ease;\n  text-align: center;\n}\n\n.custom-card:hover {\n  background-color: var(--newOrange);\n  box-shadow: 0px 5px 12px rgba(0, 0, 0, 0.15); /* Slightly larger shadow */\n}\n\n.custom-card:hover .icon-circle {\n  background-color: #ffffff;\n}\n\n.custom-card:hover .icon-circle .icon-style {\n  color: var(--newOrange);\n}\n\n.icon-circle {\n  width: 90px; /* Increased width */\n  height: 90px; /* Increased height */\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.orange-circle {\n  background-color: var(--newOrange);\n}\n\n.gray-circle {\n  background-color: #e0e0e0;\n}\n\n.icon-style {\n  font-size: 35px; /* Increased font size */\n  color: white;\n}\n\n.card-title {\n  margin-top: 1.2rem;\n  font-size: 1.5rem; /* Increased font size */\n  font-weight: 600;\n  color: #333;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .card-container {\n    flex-direction: column;\n    align-items: start;\n  }\n  .custom-card {\n    width: 90%; /* Adjusted width for mobile */\n    max-width: 280px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
